import { useState } from "react";
import Web3 from "web3";
import Menu from "../components/Menu";
import ScrollTop from "../components/ScrollTop";
import { useHistory } from "react-router-dom";
import CustomButton from "../components/CustomButton";
import connectWalletBox from "../assets/new-ui/mint/connect-wallet-box.png";
import headShark from "../assets/new-ui/mint/head-shark.png";
import IncentiveTrack from "../components/incensitive/Incensitive";
import GuideStep from "../components/guide/GuideStep";
import { useRouteRoadmap, useAddress, useNetwork } from "../contexts/Context";
import { checkCorrectNetwork, connectMetamask } from "../utils/connectMetamask";
import {
  PROXY_CONTRACT_ADDRESS,
  url,
  MINT_PRICE,
  MIN_NFT,
  MAX_NFT,
} from "../constants/config";
import ModalOptionConnect from "../components/ModalOptionConnect";
import ModalComingSoon from "../components/ModalComingSoon";
import Loading from "../components/Loading";
import { checkMintedNFT, getContractAbi } from "../services/api";
import { ethers } from "ethers";
import { formatNFTCreatedList } from "../utils/utils";
import { Modal, Box, Flex, Card, Text, Icon } from "rimble-ui";
import arrowBack from "../assets/new-ui/arrow-left.png";
import sharkAngel from "../assets/new-ui/mint/Hermes.gif";
import sharkPoseidon from "../assets/new-ui/mint/shark-poseidon.png";
import ConnectWallet from "../components/ConnectWallet";
import { isMobile } from "../utils/utils";
import QRCodeModal from "@walletconnect/qrcode-modal";
import WalletConnect from "@walletconnect/client";
import tech1 from "../assets/new-ui/about-nft/tech-1.png";
import tech2 from "../assets/new-ui/about-nft/tech-2.png";
import tech3 from "../assets/new-ui/about-nft/tech-3.png";
// import of about nft old

import character_1 from "../assets/new-ui/characters/characters-1.png";
import character_2 from "../assets/new-ui/characters/characters-2.png";
import character_3 from "../assets/new-ui/characters/characters-3.png";
import character_4 from "../assets/new-ui/characters/characters-4.png";
import character_5 from "../assets/new-ui/characters/characters-5.png";
import Attribute from "../components/Attribute";
import CoralRightType1 from "../components/coral/CoralRightType1";
import CoralLeftType1 from "../components/coral/CoralLeftType1";
import Bubble from "../components/coral/Bubble";

export default function Mint() {
  const history = useHistory();
  const web3 = new Web3(Web3.givenProvider);
  const [, setRouteRoadmap] = useRouteRoadmap();
  const [ethAddress, setEthAddress] = useAddress();
  const [networkId, setNetworkId] = useNetwork();
  const [numNFT, setNumNFT] = useState(MIN_NFT);

  const [optionConnectBox, setOptionConnectBox] = useState(false);
  const [comingSoonBox, setComingSoonBox] = useState(false);
  const [loading, setLoading] = useState(false);
  const [successBox, setSuccessBox] = useState(false);
  const [errorBox, setErrorBox] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [transactionHash, setTransactionHash] = useState(null);

  const [character1Hover, setCharacter1Hover] = useState(false);
  const [character2Hover, setCharacter2Hover] = useState(false);
  const [character3Hover, setCharacter3Hover] = useState(false);
  const [character4Hover, setCharacter4Hover] = useState(false);
  const [character5Hover, setCharacter5Hover] = useState(false);

  function updateNumNFT(type) {
    if (type === "des" && numNFT > MIN_NFT) {
      setNumNFT((old) => old - 1);
    } else if (type === "inc" && numNFT < MAX_NFT) {
      setNumNFT((old) => old + 1);
    }
  }

  function ourVision() {
    history.push("/vision");
  }

  function routeRoadmap() {
    window.scrollTo(0, 0);
    setRouteRoadmap(true);
    history.push("/");
  }

  function yourIncentive() {
    history.push("/my-nft");
  }

  function connecWallet() {
    connectMetamask().then((result) => {
      setOptionConnectBox(false);
      if (result) {
        setEthAddress(result.address);
        setNetworkId(result.network);
      }
    });
  }

  function connectTrustWallet() {
    // Create a connector
    const connector = new WalletConnect({
      bridge: "https://bridge.walletconnect.org", // Required
      qrcodeModal: QRCodeModal,
    });

    // Check if connection is already established
    if (!connector.connected) {
      // create new session
      connector.createSession();
    }

    // Subscribe to connection events
    connector.on("connect", (error, payload) => {
      // console.log('connect')
      if (error) {
        throw error;
      }

      // Get provided accounts and chainId
      const { accounts, chainId } = payload.params[0];
      // console.log('hey ya')
      // console.log(accounts)
      // console.log(chainId)
      connector.signPersonalMessage(["abc"]).then((result) => {
        // console.log(result)
      });
    });

    connector.on("session_update", (error, payload) => {
      // console.log('session update')
      if (error) {
        throw error;
      }

      // Get updated accounts and chainId
      const { accounts, chainId } = payload.params[0];
    });

    connector.on("disconnect", (error, payload) => {
      // console.log('disconnect')
      if (error) {
        throw error;
      }

      // Delete connector
    });
  }

  function openBoxConnect() {
    setOptionConnectBox(true);
  }

  function claimNFT() {
    setComingSoonBox(true);
    // setSuccessBox(true)
    // mintNFT()
  }

  async function mintNFT() {
    setLoading(true);
    try {
      let result = await getContractAbi();
      if (result.success) {
        let abi = JSON.parse(result.message.result);
        let contract = new web3.eth.Contract(abi, PROXY_CONTRACT_ADDRESS);
        contract.methods
          .claimShark(numNFT)
          .send({
            from: ethAddress,
            value: ethers.utils.parseEther((numNFT * MINT_PRICE).toString()),
          })
          .then((result) => {
            // console.log('herere')
            // console.log(result)
            let tokenList = [];
            if (result.events.NFTCreated.returnValues) {
              tokenList = [result.events.NFTCreated.returnValues.tokenId];
            } else {
              tokenList = formatNFTCreatedList(result.events.NFTCreated);
            }
            // console.log('tokenId list: ' + tokenList)
            // console.log('hash: ' + result.transactionHash)
            setTransactionHash(result.transactionHash);

            let interval = setInterval(async () => {
              let count = 0;
              for (let i = 0; i < tokenList.length; i++) {
                // console.log('tokenId: ' + tokenList[i])
                let result = await checkMintedNFT(tokenList[i]);
                if (result.success && result.message.success) {
                  // console.log('minted')
                  count++;
                }
              }
              if (count === tokenList.length) {
                setLoading(false);
                setSuccessBox(true);
                clearInterval(interval);
              }
            }, 1000);
          })
          .catch((err) => {
            setLoading(false);
            setErrorMessage("Claim NFT failed");
            setErrorBox(true);
          });
      }
    } catch (err) {
      setLoading(false);
      setErrorMessage("Claim NFT failed");
      setErrorBox(true);
    }
  }

  return (
    <div className="pageContainer mintContainer aboutNFTContainer">
      <Menu />
      <ScrollTop />
      <ConnectWallet />
      <Loading loading={loading} />

      <ModalOptionConnect
        toggleModal={optionConnectBox}
        setToggleModal={setOptionConnectBox}
        connectMetamask={connecWallet}
        connectTrustWallet={isMobile() ? connectTrustWallet : connecWallet}
      />

      <ModalComingSoon
        toggleModal={comingSoonBox}
        setToggleModal={setComingSoonBox}
      />

      {/******************* Successful box *******************/}
      <Modal isOpen={successBox}>
        <Card
          style={{
            width: "100%",
            maxWidth: "420px",
            borderRadius: 10,
            backgroundColor: "rgb(25, 27, 31)",
            border: "1px solid rgb(33, 36, 41)",
          }}
          p={0}
        >
          <Flex
            flexDirection="row"
            justifyContent="space-between"
            alignItems="center"
            color={"black"}
            p={16}
            borderBottom={"1px solid #D8D8D8"}
            mb={16}
          >
            <img
              src={arrowBack}
              alt="arrow back"
              style={{ cursor: "pointer" }}
              onClick={() => setSuccessBox(false)}
            />
            <Text
              fontSize={"24px"}
              fontWeight={600}
              color={"white"}
              className="boxTitle"
            >
              Successful!
            </Text>
            <Icon color="transparent" name="ArrowBack" />
          </Flex>
          <Box
            p={16}
            mx={16}
            mb={16}
            border={"1px solid rgb(44, 47, 54)"}
            backgroundColor={"rgb(33, 36, 41)"}
            borderRadius={"20px"}
          >
            <Text color="white" className="boxContent">
              Your NFT claimed successfully.
            </Text>
          </Box>
          <Flex justifyContent="space-around" pb={20}>
            <div
              onClick={() => history.push("/my-nft")}
              className="btn btnInBox"
            >
              Show my NFTs
            </div>
            <div
              onClick={() =>
                window.open(
                  url.bsc_testnet_explore + "/" + transactionHash,
                  "_blank"
                )
              }
              className="btn btnInBox"
            >
              Details
            </div>
          </Flex>
        </Card>
      </Modal>

      {/******************* Error box *******************/}
      <Modal isOpen={errorBox}>
        <Card
          style={{
            width: "100%",
            maxWidth: "420px",
            borderRadius: 10,
            backgroundColor: "rgb(25, 27, 31)",
            border: "1px solid rgb(33, 36, 41)",
          }}
          p={0}
        >
          <Flex
            flexDirection="row"
            justifyContent="space-between"
            alignItems="center"
            color={"black"}
            p={16}
            borderBottom={"1px solid #D8D8D8"}
            mb={16}
          >
            <img
              src={arrowBack}
              alt="arrow back"
              style={{ cursor: "pointer" }}
              onClick={() => setErrorBox(false)}
            />
            <Text
              fontSize={"24px"}
              fontWeight={600}
              color={"white"}
              className="boxTitle"
            >
              Failed!
            </Text>
            <Icon color="transparent" name="ArrowBack" />
          </Flex>
          <Box
            p={16}
            mx={16}
            mb={16}
            border={"1px solid rgb(44, 47, 54)"}
            backgroundColor={"rgb(33, 36, 41)"}
            borderRadius={"20px"}
          >
            <Flex justifyContent="center" className="boxContent">
              <Text color="white">{errorMessage}</Text>
            </Flex>
          </Box>
        </Card>
      </Modal>

      <div className="header">
        <div className="minting">
          <div>GENESIS MYSTERY BOX</div>
          <div>
            Each Sharktopia will bring in its own characteristics and be
            randomly selected from given parts. The parts of Sharktopia will be
            sorted by rarity from common to god. This ensures each Sharktopia is
            unique in appearance and rarity completely different.
          </div>
          <div>
            There is a limit to the number of Shark sold in this batch, and the
            only way to get it is through a completely random mint. Besides,
            users can also buy and sell these NFTs on the marketplace.
          </div>
        </div>
        <div className="connectWallet">
          <img src={connectWalletBox} alt="box" className="box" />
          <div className="content">
            <div className="title">SHARKTOPIA</div>
            <img src={headShark} alt="head shark" />
            {ethAddress && checkCorrectNetwork(networkId) ? (
              <div className="claimContainer">
                <div className="numNFTContainer">
                  <div
                    className={
                      numNFT === MIN_NFT
                        ? "updateNFTClaim numNFTDisable"
                        : "updateNFTClaim"
                    }
                    onClick={() => updateNumNFT("des")}
                  >
                    {" "}
                    -{" "}
                  </div>
                  <div>{numNFT}</div>
                  <div
                    className={
                      numNFT === MAX_NFT
                        ? "updateNFTClaim numNFTDisable"
                        : "updateNFTClaim"
                    }
                    onClick={() => updateNumNFT("inc")}
                  >
                    {" "}
                    +{" "}
                  </div>
                </div>
                <CustomButton
                  text={"CLAIM NFTs"}
                  textColor={"black"}
                  fn={claimNFT}
                  type={"small"}
                  transparent={false}
                />
              </div>
            ) : (
              <CustomButton
                text={"CONNECT WALLET"}
                textColor={"black"}
                fn={openBoxConnect}
                type={"medium"}
                transparent={false}
              />
            )}
          </div>
        </div>
      </div>
      <div className="incentive">
        <div className="title">INCENTIVE</div>
        <CoralRightType1 type={"small"} />
        <Bubble bottom={"-50%"} />
        <IncentiveTrack />
        <CustomButton
          text={"CHECK YOUR INCENTIVE"}
          textColor={"black"}
          fn={yourIncentive}
          type={"large"}
          transparent={false}
        />
      </div>

      <div className="need">
        <img src={sharkAngel} alt="shark angel" />
        <div className="needBox">
          <div className="title">WHAT YOU WILL NEED</div>
          <div className="description">
            To be able to mint Sharktopia, users need to have BNB. BNB can be
            purchased on many exchanges today, but we recommend users get it
            through one of two exchanges, Binance and FTX. Make sure you have at
            least 0.1 BNB to cover the transaction fees.
          </div>
          <div className="description">
            Metamask is considered the most popular exchange wallet for the BSC
            system.
          </div>
        </div>
      </div>

      <div className="guide">
        <CoralLeftType1 type={"small"} />
        <div className="guideTitle">GENERATING YOUR SHARKTOPIA</div>
        <div className="description">
          Ensure that NFT minting goes smooth, just follow these instructions:
        </div>
        <div className="stepArea">
          <GuideStep />
        </div>
      </div>

      <div className="pageGuide">
        <div className="pageTechnical">
          <div className="technicalBox">
            <div>Technical Specification</div>
            <div>
              Holy Shark is an NFT project on Binance Smart Chain (BSC). There
              are only a limited number of sharks for sale, are allowed to
              circulate and already integrated on smart contracts. Each Shark
              will include 14 parts, so in minting the Shark, the system will
              run an algorithm to ensure that each mint is unique. Each Holy
              Shark is randomly generated and locked to a specific token in the
              blockchain.
            </div>
          </div>
          <div className="technicalDetail">
            <div className="technicalTitle">
              Technical Specification Highlights
            </div>
            <div className="technicalList">
              <div className="technicalItem">
                <img src={tech1} alt="tech icon" />
                <div>
                  There are only a limited number of sharks are allowed to
                  circulate.
                </div>
              </div>
              <div className="technicalItem">
                <img src={tech2} alt="tech icon" />
                <div>Each shark is unique.</div>
              </div>
              <div className="technicalItem">
                <img src={tech3} alt="tech icon" />
                <div>Already locked to specific tokens in the blockchain.</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="pageAttribute">
        <Attribute />
      </div>

      <div className="pageDistribution">
        <div className="distributionText">
          <div className="distributionTitle">Distribution & Rarity</div>
          <ul>
            <li>
              Regarding the distribution of HLS, there will be a pre-sale event
              for the first lucky people, and then it will be open for mass
              sale. The user will proceed to mint NFT. And will get random NFT
              supplied. Each Sharktopia will carry its own characteristics and
              is randomly selected from a certain number of parts.{" "}
            </li>
            <li>
              The sections of Sharktopia will be sorted by rarity from Normal to
              Divine. This ensures each Sharktopia is unique in its appearance
              and completely different rarity. Each part of the shark will have
              another rarity, which will affect the quality of the shark through
              the stats.
            </li>
            <li>
              There is a limit to Sharktopia in this batch, and the only way to
              get it is through a completely random minting facility. Besides,
              users can also buy and sell these NFTs on the market.
            </li>
          </ul>
        </div>
        <div className="rarityList">
          <div className="rarityTitle">
            The rarity categories are as follows:
          </div>
          <ul>
            <li>Normal (~26,07%)</li>
            <li>Uncommon (~13,18%)</li>
            <li>Rare (~13,01%)</li>
            <li>Epic (~17,97%)</li>
            <li>Legendary (~10,34%)</li>
            <li>Mythic (~9,63%)</li>
            <li>Unique (~8,16%)</li>
            <li>Demi-god (~1,55%)</li>
            <li>God (Only 9 Exist!)</li>
          </ul>
        </div>
      </div>

      <div className="characters">
        <div
          className="charactersElement"
          onMouseOver={() => {
            setCharacter1Hover(true);
          }}
          onMouseOut={() => {
            setCharacter1Hover(false);
          }}
        >
          <img
            src={character_1}
            alt="characters"
            className={character1Hover ? "characterHover" : "characterNormal"}
          />
        </div>
        <div
          className="charactersElement"
          onMouseOver={() => {
            setCharacter2Hover(true);
          }}
          onMouseOut={() => {
            setCharacter2Hover(false);
          }}
        >
          <img
            src={character_2}
            alt="characters"
            className={character2Hover ? "characterHover" : "characterNormal"}
          />
        </div>
        <div
          className="charactersElement"
          onMouseOver={() => {
            setCharacter3Hover(true);
          }}
          onMouseOut={() => {
            setCharacter3Hover(false);
          }}
        >
          <img
            src={character_3}
            alt="characters"
            className={character3Hover ? "characterHover" : "characterNormal"}
          />
        </div>
        <div
          className="charactersElement"
          onMouseOver={() => {
            setCharacter4Hover(true);
          }}
          onMouseOut={() => {
            setCharacter4Hover(false);
          }}
        >
          <img
            src={character_4}
            alt="characters"
            className={character4Hover ? "characterHover" : "characterNormal"}
          />
        </div>
        <div
          className="charactersElement"
          onMouseOver={() => {
            setCharacter5Hover(true);
          }}
          onMouseOut={() => {
            setCharacter5Hover(false);
          }}
        >
          <img
            src={character_5}
            alt="characters"
            className={character5Hover ? "characterHover" : "characterNormal"}
          />
        </div>
      </div>

      {/* <div className='featureTags'>
        <div className='tag'>
          <div className='tagTitle'>About Sharktopia</div>
          <div className='tagDescription'>Frequently asked questions</div>
          <CustomButton 
            text={'VIEW DETAIL'} 
            textColor={'black'} 
            fn={() => history.push('/about-holysharks')}
            type={'small'}
            transparent={false}
          />
        </div>

        <div className='tag'>
          <div className='tagTitle'>About The Metaverse Game</div>
          <div className='tagDescription'>View the top 5 reasons to play Sharktopia Game.</div>
          <CustomButton 
            text={'VIEW DETAIL'} 
            textColor={'black'} 
            fn={() => history.push('/about-metaverse')}
            type={'small'}
            transparent={false}
          />
        </div>
      </div> */}

      {/* End About NFT old */}

      <div className="footer">
        <Bubble bottom={"5%"} />
        <div className="footerTitle">READ MORE ABOUT</div>
        <img src={sharkPoseidon} alt="shark poseidon" />
        <div className="footerBtnGroup">
          <CustomButton
            text={"OUR VISION"}
            textColor={"black"}
            fn={ourVision}
            type={"small"}
            transparent={false}
          />

          <CustomButton
            text={"ROADMAP & NFTs"}
            textColor={"black"}
            fn={routeRoadmap}
            type={"medium"}
            transparent={false}
          />
        </div>
        <div className="footerBrand">@Sharktopia 2021</div>
      </div>
    </div>
  );
}
